module.exports = __webpack_public_path__ + "img/shot_img122401.41699642.gif";